export default "__VITE_ASSET__669aef92__"